import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import React from "react";
import {
  changeFormValidity,
  selectSearchFlightsForm,
} from "../../../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useTranslation } from "react-i18next";
import { fetchResults } from "../../../SearchFlightsActions";

const validateForm = (form) => {
  const validity = {
    originAirport: true,
    destinationAirport: true,
    departingDateFilled: true,
    returningDateFilled: true,
    departingDateBeforeReturningDate: true,
  };
  if (form.originAirport === null) {
    validity.originAirport = false;
  }
  if (form.destinationAirport === null) {
    validity.destinationAirport = false;
  }
  if (form.departingDate === null) {
    validity.departingDateFilled = false;
  }
  if (form.returningDate === null) {
    validity.returningDateFilled = false;
  }
  if (
    form.departingDate !== null &&
    form.returningDate !== null &&
    form.roundTrip &&
    form.returningDate <= form.departingDate
  ) {
    validity.departingDateBeforeReturningDate = false;
  }
  return validity;
};

function SearchFlightsButtonSFO() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const loading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );
  const form = useAppSelector(selectSearchFlightsForm);

  const searchFlights = async (form) => {
    dispatch(changeFormValidity(validateForm(form)));
    if (
      form.originAirport !== null &&
      form.destinationAirport !== null &&
      form.departingDate !== null &&
      form.returningDate !== null &&
      (!form.roundTrip || form.departingDate <= form.returningDate)
    ) {
      dispatch(fetchResults({ queryTrigger: "form_submission" }));
    }
  };

  return (
    <button
      id="search-button"
      disabled={loading}
      className={`button is-primary ${loading ? " is-loading" : ""}`}
      onClick={() => {
        if (!loading) {
          searchFlights(form);
        }
      }}
    >
      <span className="icon">
        <FontAwesomeIcon icon={faSearch} />
      </span>
      <span>{t("BUTTON_SEARCH")}</span>
    </button>
  );
}

export default SearchFlightsButtonSFO;
